import React, { ReactNode, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@components-library/Tooltip';
import { ErrorLabel } from '@components-shared/forms/errorLabel';
import { HintMessage } from '@components-shared/forms/hintMessage';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';

interface IFieldLabel {
  children: ReactNode;
  name?: string;
  title?: string;
  placeholders?: Record<string, string>;
  className?: string;
  tooltip?: string | ReactNode;
  required?: boolean;
  valid?: boolean;
  validationMessage?: string;
  hintMessage?: string;
  renderAfter?: ReactNode;
  renderBefore?: ReactNode;
  testID?: string;
  labelClassName?: string;
  labelTitleClassName?: string;
  preventLabelEvent?: boolean;
  htmlFor?: string;
}

export const InputFieldWrapper = ({
  name,
  title,
  children,
  placeholders,
  className,
  tooltip,
  required,
  valid,
  validationMessage,
  renderAfter,
  renderBefore,
  hintMessage,
  testID,
  labelClassName,
  preventLabelEvent,
  htmlFor,
}: IFieldLabel) => {
  const { i18n } = useTranslation();
  const onLabelActionClick = (e: MouseEvent<HTMLLabelElement>) => {
    if (!preventLabelEvent) {
      return;
    }
    e.preventDefault();
  };

  return (
    <div className={`form__fieldset ${className || ''}`} data-fieldname={name} data-test-id={testID}>
      {renderBefore && <div className="form__field-before">{renderBefore}</div>}
      <label htmlFor={htmlFor} onClick={onLabelActionClick} className={cn('form__field', labelClassName)}>
        <div onClick={(e) => e.stopPropagation()} className="form__field-container">
          <span className={cn('form__label', tooltip && 'form__label_tooltip')}>
            {title && i18n.t(title as KeyMapKeys)}
            {required && <span className="form__required">*</span>}
            {tooltip && <Tooltip content={tooltip} />}
          </span>
          {!valid && validationMessage && <ErrorLabel message={validationMessage} placeholders={placeholders} />}
        </div>
        {children}
      </label>
      {hintMessage && <HintMessage valid={valid} message={hintMessage} />}
      {renderAfter && <div className="form__field-after">{renderAfter}</div>}
    </div>
  );
};
